import { Save, Layout, Phone, Mail, Globe } from "lucide-react";
import { PLH_INSTAGRAM_URL, PLH_PHONE, PLH_CONTACT_EMAIL } from "../../lib/constants";

export default function AdminIdentityEditor({ readOnly = false, globals, setGlobals, saving, handleSaveGlobals }) {
  return (
    <fieldset data-id="admin-identity" disabled={readOnly} className="animate-in fade-in slide-in-from-bottom-2 duration-500">
      <div className="bg-white border border-fendi/40 rounded-xl overflow-hidden shadow-sm max-w-4xl">
        <div className="px-6 py-4 border-b border-fendi/10 bg-fendi/5 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-full bg-champagne/10 flex items-center justify-center text-champagne shrink-0">
              <Layout size={16} />
            </div>
            <div>
              <h3 className="text-sm font-medium text-softblack">Identidade Visual & Contactos</h3>
              <p className="text-[10px] text-warmgray mt-0.5">Informações globais do site (não dependem de idioma)</p>
            </div>
          </div>
        </div>

        <div className="p-6">
          <div className="max-w-2xl mx-auto space-y-8">
            <div>
              <p className="text-[10px] uppercase tracking-wider text-champagne font-medium mb-4 flex items-center gap-2"><Globe size={13} /> Redes Sociais</p>
              <div className="pl-4 border-l-2 border-champagne/20">
                <label className="block max-w-lg">
                  <span className="text-[9px] uppercase tracking-wider text-warmgray font-medium">URL do Instagram</span>
                  <input className="w-full mt-1.5 px-3 py-2.5 text-sm border border-fendi/30 rounded-lg bg-transparent focus:border-champagne focus:ring-1 focus:ring-champagne/20 outline-none transition-all" value={globals?.instagram_url || ""}
                    onChange={e => setGlobals({...globals, instagram_url: e.target.value})} placeholder={PLH_INSTAGRAM_URL} />
                </label>
              </div>
            </div>

            <div className="border-t border-fendi/10 pt-8">
              <p className="text-[10px] uppercase tracking-wider text-champagne font-medium mb-5 flex items-center gap-2"><Phone size={13} /> Contactos</p>
              <div className="pl-4 border-l-2 border-champagne/20 grid md:grid-cols-2 gap-6">
                <label className="block">
                  <span className="text-[9px] uppercase tracking-wider text-warmgray font-medium flex items-center gap-1.5"><Phone size={11} className="shrink-0" /> WhatsApp</span>
                  <input className="w-full mt-1.5 px-3 py-2.5 text-sm border border-fendi/30 rounded-lg bg-transparent focus:border-champagne focus:ring-1 focus:ring-champagne/20 outline-none transition-all" value={globals?.whatsapp_number || ""}
                    onChange={e => setGlobals({...globals, whatsapp_number: e.target.value})} placeholder={PLH_PHONE} />
                </label>
                <label className="block">
                  <span className="text-[9px] uppercase tracking-wider text-warmgray font-medium flex items-center gap-1.5"><Mail size={11} className="shrink-0" /> E-mail de Contacto</span>
                  <input className="w-full mt-1.5 px-3 py-2.5 text-sm border border-fendi/30 rounded-lg bg-transparent focus:border-champagne focus:ring-1 focus:ring-champagne/20 outline-none transition-all" value={globals?.contact_email || ""}
                    onChange={e => setGlobals({...globals, contact_email: e.target.value})} placeholder={PLH_CONTACT_EMAIL} />
                </label>
              </div>
            </div>
          </div>
        </div>

        {!readOnly && (
          <div className="px-6 py-4 border-t border-fendi/10 bg-fendi/5 flex justify-end">
            <button onClick={handleSaveGlobals} disabled={saving} className="btn-primary !py-2.5 !px-8 !text-[11px]">
              <Save size={13} className="mr-2" /> {saving ? "A guardar..." : "Guardar Identidade"}
            </button>
          </div>
        )}
      </div>
    </fieldset>
  );
}
